import { Power3, TimelineLite } from "gsap"
import React, { useContext, useEffect, useRef, useState } from "react"
import styled from "styled-components"

import Pineapple from "../elements/Pineapple"
import { ScrollerContext } from "../elements/SmoothScroll/context"
import Tiger from "../elements/Tiger"
import Splash from "./Splash"

const Container = styled.section`
  min-height: 100vh;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  grid-template-rows: auto 1.5fr;
  grid-template-areas: "icon . logo" "country intro social";
  padding: var(--gutter-s);
  color: var(--deep-teal);
  @media (min-width: 768px) {
    grid-template-columns: 75px 1fr 75px;
  }
  @media (min-width: 1024px) {
    grid-template-columns: 100px 1fr 100px;
  }
  @media (min-width: 1440px) {
  }
`

const Icon = styled.div`
  /* background-color: rgba(255, 0, 0, 0.5); */
  grid-area: icon;
`
const Logo = styled.div`
  /* background-color: rgba(255, 255, 0, 0.5); */
  grid-area: logo;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  a {
    font-size: 0.9rem;
    letter-spacing: 2px;
    line-height: 0.95;
    span {
      font-family: "Greycliff_CF_Bold";
    }
  }
`
const Country = styled.p`
  /* background-color: rgba(0, 255, 0, 0.5); */
  grid-area: country;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: none;
  justify-content: center;
  font-size: 0.8rem;
  transform: scale(-1);
  @media (min-width: 768px) {
    display: flex;
  }
`
const Social = styled.div`
  /* background-color: rgba(255, 0, 255, 0.5); */
  grid-area: social;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  a {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    padding: 0.25rem 0;
    margin: 0.25rem 0;
    font-size: 0.8rem;
  }
  @media (min-width: 768px) {
    display: flex;
  }
`
const Intro = styled.div`
  /* background-color: rgba(0, 255, 255, 0.5); */
  grid-area: intro;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  h1 {
    font-size: 4rem;
    font-family: "Botanica";
    line-height: 0.95;
    color: var(--deep-teal);
    position: relative;
    opacity: 0;
    transform: translateY(30px);
  }
  p {
    font-size: 0.8rem;
    opacity: 0;
  }
  @media (min-width: 768px) {
    h1 {
      font-size: 8rem;
    }
  }
  @media (min-width: 1024px) {
    h1 {
      font-size: 15vh;
    }
  }
  @media (min-width: 1200px) {
    h1 {
      font-size: 25vh;
    }
  }
`

const Illustrations = styled.div`
  grid-row: 1 / -1;
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Landing = () => {
  const context = useContext(ScrollerContext)

  const [enter, setEnter] = useState(false)
  const [animateTiger, setAnimateTiger] = useState(false)

  const scrollEl = useRef(null)

  const { setActive } = context

  useEffect(() => {
    const delay = 1000
    if (enter) {
      let tl = new TimelineLite()
      const headings = document.getElementsByClassName("heading")
      window.setTimeout(() => {
        setAnimateTiger(true)
        tl.staggerTo(
          headings,
          1.5,
          { y: -30, opacity: 1, ease: Power3.easeOut },
          0.25
        ).to(
          scrollEl.current,
          1.5,
          {
            y: -15,
            opacity: 1,
            ease: Power3.easeOut,
            onStart: () => {
              setActive()
            },
          },
          "-=0.5"
        )
      }, delay)
    }
  }, [enter, setActive])

  return (
    <Container>
      <Icon>
        <Pineapple />
      </Icon>
      <Logo>
        <a
          href="https://teamgeek.io/"
          className="mouse-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Team <br />
          geek <br />
          <span>2019</span>
        </a>
      </Logo>
      <Country>Made in South Africa</Country>
      <Social>
        <a
          href="https://www.instagram.com/teamgeek_/"
          target="_blank"
          rel="noopener noreferrer"
          className="mouse-link"
        >
          Instagram
        </a>
        <a
          href="https://twitter.com/weareteamgeek"
          target="_blank"
          rel="noopener noreferrer"
          className="mouse-link"
        >
          Twitter
        </a>
        <a
          href="https://www.facebook.com/weareteamgeek/?hc_ref=ARQMQAcZkcd0r-DQhaZ2HwdbrWA0Xxz7Txck65FIMw3t9QxqBBQBjDpF153ue834yjo&__xts__%5B0%5D=68.ARB1YTGMiVQesuxHT6NcsTpqgZ5JagkyBUKZqVHj-vK9s2LRbbzwdbX2r1XyQCzztbgu8kg0EULDRod37WuUu2_-hoKm2mZsVqSP2WSpyY80B4ZwzxNRQapx9XBd1dle08UAYdJWi9cJA1lf_za__fjMt7UhEgTv_mDyWJaXGp4YGhLqSo6qA3O-XVvsOBzpS4x84CN3VBC2UIQUpDo_ehCRgdpJpfTrX8Z9NL3I3GJquGmKBPAW6RatSfnepLE371EQzvBeWwOLuiU6jEp1pTGNhoD6GNLKAZNpPorCtU51ccLhrlALYntem-n4c4Nif-XoXCVjTwY4KyqPQw9Uk-lle113FQg0q3CP1HYAz6-ULk2H9kTqHJBh_braE8JBv8dYdduBZEJjiVcpRObZMofpVc-xPfxx-57DpCj95UE&__tn__=kC-R"
          target="_blank"
          rel="noopener noreferrer"
          className="mouse-link"
        >
          Facebook
        </a>
        <a
          href="https://dribbble.com/teamgeek"
          target="_blank"
          rel="noopener noreferrer"
          className="mouse-link"
        >
          Dribbble
        </a>
      </Social>
      <Intro>
        <h1 className="heading">Year in</h1>
        <h1 className="heading">Review</h1>
        <p ref={scrollEl}>Scroll for Radness</p>
      </Intro>
      <Illustrations>
        <Tiger start={animateTiger} />
      </Illustrations>
      <Splash onExitStart={setEnter} />
    </Container>
  )
}

export default Landing
